import React, { useState, useEffect, useRef } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { Badge, Col, Row, Button } from 'react-bootstrap';
import { ThreeDots } from '../../common/Placeholders.jsx';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import { getCollectionGenres } from '../../../actions/collection';


const CollectionGenres = ({ genres, getCollectionGenres }) => {
  let history = useHistory();
  let ref = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { getCollectionGenres().then(() => setIsLoading(false)); }, []);

  const handleClick = (slug) => {
    ref.current.scrollIntoView({ top: '-10px', behavior: 'smooth'});
    history.push(slug + `/`);
  }

  let items;
  if (genres.length){
    items = genres.map(i => (
      <Col key={ i.id } xs={12} md={6} className={'mb-3'}>
        <Button onClick={ () => handleClick(i.slug) }
                variant={ 'outline-dark' }
                className={'d-flex btn-fat_width_100 text-left'}
                title={ gettext('Посмотреть все аранжировки жанра') + ' ' + i.name }>
          <span className='flex flex-grow-1'>{ i.name }</span>
          <span><Badge variant={ i.count === 0 ? 'primary' : 'success' }>{ i.count }</Badge></span>
        </Button>
      </Col>))
  }

  return(
    <div ref={ref}>
      <Row>
        { isLoading ? <ThreeDots/> : items }
      </Row>
    </div>
  )
}

CollectionGenres.propTypes = {
  genres: PropTypes.array.isRequired,
  getCollectionGenres: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    genres: state.collection.genres
  }
};

export default compose(
  connect(mapStateToProps, { getCollectionGenres }),
  LoginRequired,
  Page
)(CollectionGenres);

